import { useEffect, useState } from "react";
import InfinityPOSAuthGridCard from "../../common/cardContainers/InfinityPOSAuthGridCard";
import { APP_TITLE } from "../../../config/constant";
import { useOutletContext } from "react-router";
import ListComponent from "../../common/lists/ListComponent";
import { useSelector } from "react-redux";
import * as Library from "../../../utils/Library";
import FullScreenLoader from "../../common/loaders/FullScreenLoader";
import { AppQueryClient } from "../../../api/queryClient";
import MainWindowHeader from "../../common/mainApp/mainWindowHeaders/MainWindowHeader";
import moment from "moment";

export default function POSAuth() {
    document.title = `${APP_TITLE} - POS Auth`;

    // #region VARS
    // eslint-disable-next-line no-unused-vars
    const [isLoading, setIsLoading] = useState(false);

    const [viewLayoutStyle, setViewLayoutStyle] = useState("Grid");
    const { MainLayoutProps, layoutType } = useOutletContext();
    const navigations = useSelector(state => state.navigationAccesses);

    const [listNumRows, setListNumRows] = useState(50);

    const listColumns = [
        {
            name: "Authorization Name",
            selector: row => row?.name || "--"
        },
        {
            name: "Created by",
            selector: row => row?.createdBy || "--"
        },
        {
            name: "Created on",
            selector: row => formatIsoToDateTime(row?.createdAt) || "--"
        },
        {
            name: "POS",
            selector: row => row?.posName || "--"
        },
        {
            name: "Environment",
            selector: row => row?.environment || "--"
        },
        {
            name: "Type",
            selector: row => row?.type || "--"
        },
        {
            name: "Total Fields",
            selector: row => row?.totalFields || "--"
        }
    ];

    const infiniteGridQuerykey = ["POSAuthGrid"];
    const listQueryKey = ["POSAuthList"];

    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData
    };

    //---------- Header Filters
    const [allPOSList, setAllPOSList] = useState([]);
    const [allEnvironmentsList, setAllEnvironmentsList] = useState([]);
    //----------
    const [selectedPOS, setSelectedPOS] = useState(undefined);
    const [selectedEnvironment, setSelectedEnvironment] = useState(undefined);

    const filters = {
        posIDs: [JSON.parse(localStorage.getItem("POSs"))[0]?._id] || [],
        environmentNames: JSON.parse(localStorage.getItem("POSs"))[0]?.environments || []
    };
    // #endregion

    // #region METHODS
    const onPageStart = async () => {
        // get all POSs
        const posListRaw = JSON.parse(localStorage.getItem("POSs")) || [];
        const allPOS = posListRaw?.map(pos => ({
            value: pos?._id,
            name: pos?.name
        }));
        setAllPOSList(allPOS);
        setSelectedPOS(allPOS.length > 0 ? [{ value: allPOS[0].value, name: allPOS[0].name }] : []);

        // get all environments
        let allEnvironments = posListRaw?.[0]?.environments;
        allEnvironments = allEnvironments?.map(env => ({
            value: env,
            name: env
        }));
        setAllEnvironmentsList(allEnvironments);
        setSelectedEnvironment(
            allEnvironments.length > 0 ? [{ value: allEnvironments[0].value, name: allEnvironments[0].name }] : []
        );
    };

    const onPOSChange = pos => {
        setSelectedPOS([pos]);
    };

    const onEnvironmentChange = environment => {
        setSelectedEnvironment([environment]);
    };

    const onClickRefreshAction = () => {
        if (props?.layoutType === "List") AppQueryClient.invalidateQueries(listQueryKey);
        else AppQueryClient.invalidateQueries(infiniteGridQuerykey);
    };

    const handleDelete = async row => {
        //console.log("handleDelete", row);

        const formData = {
            posID: row?.posID,
            environmentName: row?.environmentName
        };

        const res = await Library.makePostRequest("deleteAuthorization", formData, false, setIsLoading);
        if (res.data.status !== 200) return;
        //const data = res.data?.data?.result;

        Library.showToastMessage({
            type: "success",
            message: "Authorization deleted successfully."
        });
    };

    const formatIsoToDateTime = isoDate => {
        if (!isoDate) return "--";
        const res = moment(isoDate).format("DD/MM/YYYY HH:mm");
        if (res === "Invalid date") return "--";
        return res;
    };
    // #endregion Methods

    // #region EFFECTS
    useEffect(() => {
        setViewLayoutStyle(props?.layoutType);

        setupHeaders(
            props,
            onClickRefreshAction,
            navigations,
            allPOSList,
            allEnvironmentsList,
            onPOSChange,
            onEnvironmentChange,
            selectedPOS,
            selectedEnvironment
        );
    }, [props?.layoutType, navigations, allPOSList, allEnvironmentsList, selectedPOS, selectedEnvironment]);

    useEffect(() => {
        onPageStart();
    }, []);
    // #endregion EFFECTS

    // #region RENDER
    return (
        <>
            <FullScreenLoader isLoading={isLoading} />

            {viewLayoutStyle === "Grid" && (
                <InfinityPOSAuthGridCard
                    minColumnWidth="395px"
                    limit={10}
                    queryKey={infiniteGridQuerykey}
                    primaryButton={{
                        title: "DETAILS"
                    }}
                    filters={filters}
                    // onAcceptInvitation={handleAcceptInvitation}
                    // onDeclineInvitation={onOpenDeclineDialog}
                    onDeleteAction={handleDelete}
                    // requestEnabled={requestEnabled}
                />
            )}
            {viewLayoutStyle === "List" && (
                <ListComponent
                    title="Authorizations"
                    //title2="(LAST 10 INVITED)"
                    columns={listColumns}
                    api={{
                        endpoint: "getAuthorizationsData",
                        useCommonPostRequest: false,
                        formData: {
                            companyID: localStorage.getItem("currentCompanyID"),
                            limit: listNumRows
                        },
                        onSuccess: data => {
                            data = data?.result?.map(item => {
                                const newItem = item?.authorizations?.[0] || {};
                                newItem.totalFields = item?.authorizations?.length || 0;
                                return newItem;
                            });
                            return data;
                        }
                    }}
                    pageLimit={listNumRows}
                    currentPage={1}
                    queryKey={listQueryKey}
                    actions={{
                        includeActions: true,
                        editIsVisible: true,
                        suspendIsVisible: false,
                        removeIsVisible: true,
                        onClickRemove: handleDelete,
                        extraActions: [
                            {
                                title: "DETAILS",
                                onClick: row => {
                                    return undefined;
                                },
                                isDisabled: row => {
                                    return true;
                                }
                            },
                            {
                                title: "ADD NEW",
                                onClick: row => {
                                    return undefined;
                                },
                                isDisabled: row => {
                                    return true;
                                }
                            }
                        ]
                    }}
                    /* includeStatus={{
                        stickyStatus: true,
                        statusFromPath: "status",
                        statusColors: defaultStatusColors
                    }} */
                    //requestEnabled={requestEnabled}
                    onChangeRowsPerPage={rowsPerPage => setListNumRows(rowsPerPage)}
                />
            )}
        </>
    );
    // #endregion RENDER
}

// #region FUNCTIONS
function setupHeaders(
    props,
    onClickRefreshAction,
    navigations,
    allPOSList,
    allEnvironmentsList,
    onPOSChange,
    onEnvironmentChange,
    selectedPOS,
    selectedEnvironment
) {
    const createMode = navigations?.navigationAccesses?.retailers?.createModeOnly;

    //const currentPOSID = localStorage.getItem("currentPOSID");
    //const routePOSEdit = `/pos/edit/${currentPOSID}`;

    props.setControlBarLeftBtns([
        //{ to: "#", disabled: true, title: "Retailers", icon: "fa-magnifying-glass", isSearchToogle: false }
    ]);
    props.setControlBarCenterBtns([
        { to: "/pos", active: false, disabled: false, title: "POS" },
        { to: "/pos/setup", active: false, disabled: false, title: "SETUP" },
        { to: "/pos/connectfields", active: false, disabled: false, title: "CONNECT FIELDS" },
        { to: "/pos/auth", active: true, disabled: false, title: "AUTH" }
    ]);
    props.setControlBarRightBtns([
        { to: "#", active: true, disabled: createMode, title: "View", icon: "eye" },
        { to: "/pos/create", active: false, disabled: true, title: "Add", icon: "plus" },
        { to: "#", active: false, disabled: true, title: "Details", icon: "microscope" }
        //{ to: routePOSEdit, active: false, disabled: !currentPOSID, title: "Edit", icon: "edit" }
    ]);

    props.setFilterHeaderProperties({
        customContentHeader: (
            <MainWindowHeader
                key={window.location.pathname}
                visible={true}
                layoutTypeOptions={{
                    gridEnabled: true,
                    listEnabled: true
                }}
                onRefreshClick={onClickRefreshAction}
                firstOrganize={{
                    visible: true,
                    dropdownData: allPOSList,
                    onDropdownChange: onPOSChange,
                    disabled: false,
                    type: "singleSelect",
                    selectedValue: selectedPOS?.[0]?.name
                }}
                secondOrganize={{
                    visible: true,
                    dropdownData: allEnvironmentsList,
                    onDropdownChange: onEnvironmentChange,
                    type: "singleSelect",
                    selectedValue: selectedEnvironment?.[0]?.name
                }}
                pageFilters={{
                    useFilters: false
                }}
            />
        )
    });
}
// #endregion FUNCTIONS
